import React, { Component, PropTypes } from 'react';
import deepEqual from 'deep-equal'
import Style from 'style-it';
import _ from 'lodash'

class AddonContentInside extends Component {

  constructor(props) {
    super(props);
    this.state = {
      settings: this.props.addon.settings,
      htmlContent: '',
      cssContent: ''
    };
  }
  
  addonAssets() {
    const { addon } = this.props;

    let assets = addon.assets;
    
    if(addon.assets == undefined){
      assets = this.state.cssContent;
    }
    // assets
    if(assets != '') {
      // CSS
      if(assets.css != undefined) {
        var css = window.frames['sp-pagebuilder-view'].window.document.createElement('style');
        css.setAttribute( 'type', 'text/css' );
        css.id = 'addon-style-' + addon.id;

        if(window.frames['sp-pagebuilder-view'].window.document.getElementById(css.id) != undefined) {
          window.frames['sp-pagebuilder-view'].window.document.getElementById(css.id).remove();
        }

        if (css.styleSheet) {
          css.styleSheet.cssText = assets.css;
        } else {
          css.appendChild(window.frames['sp-pagebuilder-view'].window.document.createTextNode(assets.css));
        }

        window.frames['sp-pagebuilder-view'].window.document.getElementsByTagName('head')[0].appendChild( css );
      }

      // JS
      if(assets.js != undefined) {
        var script = window.frames['sp-pagebuilder-view'].window.document.createElement('script');
        script.setAttribute( 'type', 'text/javascript' );
        script.id = 'addon-script-' + addon.id;
        script.setAttribute( 'async', true );
        script.text = assets.js;
        window.frames['sp-pagebuilder-view'].window.document.getElementsByTagName('head')[0].appendChild( script );
      }
    }

    if(addon.name == 'gmap') {
      initSPPageBuilderGMap();
    }
  }

  componentDidMount(){
    const { addon } = this.props;
    this.addonAssets();
  }

  shouldComponentUpdate( nextProps, nextState ) {
    if( !deepEqual( nextProps.addon.settings, nextState.settings ) ) {
      return true;
    }

    if(nextState.htmlContent != ''){
      return true;
    }

    return false;
  }

  componentDidUpdate(){
    const { settings } = this.state;
    const { addon } = this.props;

    if( !deepEqual( this.props.addon.settings, settings ) ) {
      this.setState({
        settings: this.props.addon.settings,
      });
    }

    this.addonAssets();

  }

  renderAddon(){

    const { addon } = this.props;

    _.templateSettings.evaluate = /<#([\s\S]+?)#>/g;
    _.templateSettings.interpolate = /\{\{\{([\s\S]+?)\}\}\}/g;
    _.templateSettings.escape = /\{\{([^\}]+?)\}\}(?!\})/g;
    _.templateSettings.variable = 'data';
    
    let template = document.getElementById('sppb-tmpl-addon-'+addon.name);
    
    if(template){
      var compiled = _.template(template.innerHTML);

      addon.settings.id = addon.id;

      return compiled(addon.settings);
    }

    if(!template && typeof addon.htmlContent === 'undefined' && this.state.htmlContent == ''){
      jQuery.ajax({
          type: 'POST',
          url: pagebuilder_base + 'index.php?option=com_sppagebuilder&view=ajax&format=json&callback=addon',
          dataType: 'json',
          data: {
            addon: addon
          },
          cache: false,
          success: function(response) {

            if(response.status == 'true'){

              this.setState({
                htmlContent: response.html,
                cssContent: response.assets
              })
            }
          }.bind(this)
        });
    } else if(this.state.htmlContent){
      return this.state.htmlContent;
    }

    return addon.htmlContent;
  }

  render() {
    const { addon } = this.props;

    let htmlContent = this.renderAddon()

    if(this.state.htmlContent != ''){
      htmlContent = this.state.htmlContent
    }

    let addonIdForCSS = 'sppb-addon-' + addon.id;

    let backgroundColor = '';
    if(addon.settings.global_use_background && addon.settings.global_background_color){
      backgroundColor = addon.settings.global_background_color
    }

    let backgroundImage = '';
    if(addon.settings.global_use_background && addon.settings.global_background_image){
      backgroundImage = 'url('+addon.settings.global_background_image+')'
    }

    let borderRadius = '';
    if(addon.settings.global_border_radius){
      borderRadius = addon.settings.global_border_radius+'px'
    }

    let margin = '';
    let margin_sm = '';
    let margin_xs = '';
    if(addon.settings.global_margin){
      if(_.isObject(addon.settings.global_margin)){
        margin = addon.settings.global_margin.md.split(' ').map(item => {
          if(_.isEmpty(item)){
            return '0';
          }
          return item;
        }).join(' ')
        margin_sm = addon.settings.global_margin.sm.split(' ').map(item => {
          if(_.isEmpty(item)){
            return '0';
          }
          return item;
        }).join(' ')
        margin_xs = addon.settings.global_margin.xs.split(' ').map(item => {
          if(_.isEmpty(item)){
            return '0';
          }
          return item;
        }).join(' ')
      } else {
        margin = addon.settings.global_margin.split(' ').map(item => {
          if(_.isEmpty(item)){
            return '0';
          }
          return item;
        }).join(' ')
      }
      
    }

    let padding = '';
    let padding_sm = '';
    let padding_xs = '';
    if(addon.settings.global_padding){
      if(_.isObject(addon.settings.global_padding)){
        padding = addon.settings.global_padding.md.split(' ').map(item => {
          if(_.isEmpty(item)){
            return '0';
          }
          return item;
        }).join(' ')
        padding_sm = addon.settings.global_padding.sm.split(' ').map(item => {
          if(_.isEmpty(item)){
            return '0';
          }
          return item;
        }).join(' ')
        padding_xs = addon.settings.global_padding.xs.split(' ').map(item => {
          if(_.isEmpty(item)){
            return '0';
          }
          return item;
        }).join(' ')
      } else {
        padding = addon.settings.global_padding.split(' ').map(item => {
          if(_.isEmpty(item)){
            return '0';
          }
          return item;
        }).join(' ')
      }
      
    }

    let borderWidth = '';
    if(addon.settings.global_user_border && addon.settings.global_border_width){
      borderWidth = addon.settings.global_border_width+'px'
    }

    let borderColor = '';
    if(addon.settings.global_user_border && addon.settings.global_border_color){
      borderColor = addon.settings.global_border_color
    }

    let borderStyle = '';
    if(addon.settings.global_user_border && addon.settings.global_boder_style){
      borderStyle = addon.settings.global_boder_style
    }

    return Style.it(`
      #${ addonIdForCSS }{
        color: ${ addon.settings.global_text_color };
        background-color: ${ backgroundColor };
        background-image: ${ backgroundImage };
        border-radius: ${ borderRadius };
        margin: ${ margin };
        padding: ${ padding };
        border-width: ${ borderWidth };
        border-color: ${ borderColor };
        border-style: ${ borderStyle };

      }
      #${ addonIdForCSS } a{
        color: ${ addon.settings.global_link_color };
      }
      #${ addonIdForCSS } a:hover,
      #${ addonIdForCSS } a:focus,
      #${ addonIdForCSS } a:active{
        color: ${ addon.settings.global_link_hover_color };
      }
      @media (min-width: 768px) and (max-width: 991px) {
        #${ addonIdForCSS }{
          padding: ${ padding_sm };
          margin: ${ margin_sm };
        }
      }
      @media (max-width: 767px) {
        #${ addonIdForCSS }{
          padding: ${ padding_xs };
          margin: ${ margin_xs };
        }
      }
      `,
      <div key="1">
        <div dangerouslySetInnerHTML={ { __html: htmlContent } }/>
        {/*<div dangerouslySetInnerHTML={ { __html: addon.htmlContent } } />*/}
      </div>
    )
  }
}

export default AddonContentInside;



// WEBPACK FOOTER //
// ./src/components/AddonContentInside.js